import http from 'conversations-http/clients/http';
export const editSpaceClient = ({
  id,
  updates
}) => {
  //API docs: https://tools.hubteam.com/api-catalog/services/hd-spaces-service/v1/spec/internal#operations-Space-put-%2Fhd-spaces%2Fv1%2Fspaces%2F%7Bid%7D
  return http.put(`hd-spaces/v1/spaces/${id}`, {
    data: updates
  });
};